import { useRecoilState } from "recoil";
import { productKeyAtom } from "src/atoms";

// Wrapsody사이트인지 파악
export const useIsWrapsodyProduct = () => {
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);

  return { isWrapsody: productKey === "WRAPSODY" };
};
